import type {FC} from 'react';
import {AuthActionButtons} from './Presenter/AuthActionButtons';

type Props = {
  isStudentVerificationRequired?: boolean;
};

export const PostFormAuthBox: FC<Props> = ({
  isStudentVerificationRequired = false,
}) => {
  return (
    <div className="relative bg-white p-16 shadow-modal rounded-12 mt-16">
      <div className="blur-[4px] pointer-events-none select-none">
        <p className="text-base font-bold text-black-1 leading">
          知りたいことを投稿してみましょう
        </p>
        <div className="mt-12">
          <div>
            <label
              htmlFor="post-nickname"
              className="text-base font-bold text-black-1 leading block mb-8"
            >
              ニックネーム
            </label>
            <input
              id="post-nickname"
              placeholder="ニックネーム"
              className="border-[1px] border-line border-collapse p-8 w-full rounded-[8px] text-base"
              disabled
              type="text"
            />
          </div>
          <div className="pt-16">
            <div className="flex flex-wrap mb-8">
              <label
                htmlFor="post-title"
                className="text-base font-bold text-black-1 leading block"
              >
                タイトル
              </label>
              <span className="block bg-notification-1 text-white text-xs py-[2px] px-4 rounded-full leading ml-4">
                必須
              </span>
            </div>
            <input
              id="post-title"
              placeholder="【外コン】夏インターンの戦略的撤退はあり？"
              className="border-[1px] border-line border-collapse p-8 w-full rounded-[8px] text-base"
              disabled
              type="text"
            />
          </div>
          <div className="pt-16">
            <div className="flex flex-wrap mb-8">
              <label
                htmlFor="post-content"
                className="text-base font-bold text-black-1 leading block"
              >
                投稿内容
              </label>
              <span className="block bg-notification-1 text-white text-xs py-[2px] px-4 rounded-full leading ml-4">
                必須
              </span>
            </div>
            <textarea
              id="post-content"
              placeholder=""
              rows={4}
              className="border-[1px] border-line border-collapse p-8 w-full rounded-[8px] text-base"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <p className="text-center text-black-1 text-base font-bold mb-12">
          {isStudentVerificationRequired
            ? '大学認証を完了すると投稿できます'
            : '会員登録すると投稿できます'}
        </p>
        <AuthActionButtons
          isStudentVerificationRequired={isStudentVerificationRequired}
        />
      </div>
    </div>
  );
};
